import React, { Component } from 'react';

class Quote extends Component {
  render() {
    return (
      <section id="quote">
        <div className="container">
          <blockquote className="text-center">
            <h3 className="quote_title h3-reponsive mb-5">Peluang Investasi Akhirat</h3>
            <p className="quote_desc align-self-center pl-5 pr-5">"Jika manusia mati, maka terputuslah amalnya kecuali tiga perkara: <strong>(1)</strong> <span className="blue-text">sedekah jariyah</span><strong>, (2) ilmu yang diambil manfaatnya,</strong> <strong>(3) anak shalih yang selalu didoakan orang tuanya</strong>"</p>
            <em>(HR. Muslim)</em>
          </blockquote>
          <hr />
        </div>
      </section>
    )
  }
}

export default Quote;



// WEBPACK FOOTER //
// ./src/components/Quote.js